const theme = {
  'primaryColor': '#37766F',
  'globalHeader': {
    'headerIcon': 'arrow',
  }
}

export { theme }